import _ from 'underscore';

export function extractFilter(filter) {
  const queriesBeforeExtract = filter.$and || [filter];
  return _.map(queriesBeforeExtract, (item) => {
    const columnName = _.first(_.keys(item));
    const operator = _.first(_.keys(_.result(item, columnName)));
    const value = _.first(_.values(_.result(item, columnName)));
    return {
      columnName,
      operator,
      value,
    };
  });
}

function convertToLowerCase(val) {
  if (_.isArray(val)) {
    return _.map(val, convertToLowerCase);
  } else if (typeof val === 'string') {
    return val.toLowerCase();
  }
  return val;
}

function handleQuery(query, rowData) {
  const column = query.columnName;
  const { operator } = query;
  const columnData = _.has(rowData, column) ?
    _.result(rowData, column) : _.result(_.result(rowData, 'PerformanceMetrics'), column);

  if (!_.isString(columnData) && !_.isNumber(columnData)) {
    throw Error('Cant get the column data by the column name');
  }

  const val = query.value;
  const valSl = convertToLowerCase(val);
  const columnDataSl = convertToLowerCase(columnData);

  switch (operator) {
    case '$eq':
      return columnDataSl === valSl;
    case '$neq':
      return columnDataSl !== valSl;
    case '$gt':
      return columnData > val;
    case '$gte':
      return columnData >= val;
    case '$lt':
      return columnData < val;
    case '$lte':
      return columnData <= val;
    case '$contains':
      return columnDataSl.indexOf(valSl) >= 0;
    case '$doesnotcontain':
      return columnDataSl.indexOf(valSl) < 0;
    case '$startswith':
      return columnDataSl.indexOf(valSl) === 0;
    case '$in':
      return valSl.indexOf(columnDataSl) >= 0;
    case '$endswith': {
      return columnDataSl.substr(columnDataSl.indexOf(valSl), columnDataSl.length) === val;
    }
    default:
      throw Error('The operator is invalid');
  }
}

export function filterData(queries, data) {
  // Always include 'You' when filtering.
  return _.filter(data, (item) => {
    const domainVal = _.result(item, 'DisplayDomain');
    const isYou = domainVal && domainVal === 'You';
    return isYou || _.reduce(
      queries,
      (memo, query) => memo && handleQuery(query, item),
      true
    );
  });
}
